import { Edit as EditIcon } from "@mui/icons-material";
import { PlaylistAdd as PlaylistAddIcon } from "@mui/icons-material";
import type { MenuOptionType } from "../../../../../controls/contextMenu/models/MenuOptionType";
import type { CatalogElement } from "../../../models/CatalogElement";

type Props = {
  setElement: (element: CatalogElement) => void;
  setShowModal: (show: "new" | "edit" | "delete" | "") => void;
  handleNewElement: () => void;
};
export const useElementsOptionsFunctions = ({
  setElement,
  setShowModal,
  handleNewElement,
}: Props) => {
  const getMenuOptions = (data: CatalogElement) => {
    let options: MenuOptionType[] = [
      {
        name: "New Element",
        key: "new_element",
        onClick: () => {
          handleNewElement();
        },
        icon: <PlaylistAddIcon />,
      },
    ];
    if (data) {
      options = options.concat([
        {
          name: "Edit Element",
          key: "edit_element",
          onClick: () => {
            setElement(data);
            setShowModal("edit");
          },
          icon: <EditIcon />,
        },
      ]);
    }
    return options;
  };
  return {
    getMenuOptions,
  };
};
